import api from '../api'

export const getEventTypes = async (data: { page: number; page_size: number }) => {
  const res = await api.get('event_types/', { params: data })
  return res.data
}

export const postEventType = async (data: any) => {
  // Use FormData if there's an image
  if (data.image instanceof File) {
    const formData = new FormData()
    formData.append('type', data.type)
    formData.append('display_name', data.display_name)
    formData.append('image', data.image)
    const res = await api.post('event_types/', formData)
    return res.data
  }
  const res = await api.post('event_types/', data)
  return res.data
}

export const putEventType = async ({ type, data }: { type: string; data: any }) => {
  // Use FormData if there's an image
  if (data.image instanceof File) {
    const formData = new FormData()
    formData.append('display_name', data.display_name)
    formData.append('image', data.image)
    const res = await api.put(`event_types/${type}/`, formData)
    return res.data
  }
  const res = await api.put(`event_types/${type}/`, data)
  return res.data
}

export const deleteEventType = async ({ type }: { type: string }) => {
  const res = await api.delete(`event_types/${type}/`)
  return res.data
}

export const postSessionToken = async () => {
  const res = await api.post('user/token/')
  return res.data
}

export const getVenueHosts = async (data: { venue_id?: string; all?: boolean }) => {
  const res = await api.get('event/admin/venue-hosts/', { params: data })
  return res.data
}

export const postAdminEvent = async (data: {
  title: string
  coaches: string[]
  type: string
  secondary_type?: string
  skill_level: number[]
  surface: number
  venue: string
  // Venue-wall-clock contract; the backend combines these in venue.timezone.
  start_date?: string
  start_time_local?: string
  start_time?: string
  court_fk?: string | null
  is_special_event?: boolean
  memberships_excluded?: boolean
  duration: number
  venue_fixed_rate: string
  venue_hourly_rate: string
  max_players: number
  description: string
  private_code: string | null
  fee: string
  // Required for the admin create path: member_profile id of the selected host.
  host: string
  is_recurring?: boolean
  recurrence_type?: string
  recurrence_end_date?: string
}) => {
  const res = await api.post('event/admin/create/', data)
  return res.data
}

export const postEventParticipant = async (data: { event_id: string; member_id: string }) => {
  const res = await api.post('admin/events/participants/', data)
  return res.data
}

export const deleteEventParticipant = async (data: { event_id: string; member_id: string }) => {
  const res = await api.delete('admin/events/participants/', { data })
  return res.data
}

export const getEventLogs = async (id: string) => {
  const res = await api.get(`events/${id}/logs/`)
  return res.data
}

export interface InternalTag {
  id: string
  name: string
  slug: string
  is_active: boolean
  description: string
  event_count?: number
  package_count?: number
}

export const getInternalTags = async (data: { page?: number; page_size?: number; is_active?: boolean }) => {
  const params = new URLSearchParams()
  if (data.page) params.set('page', String(data.page))
  if (data.page_size) params.set('page_size', String(data.page_size))
  if (data.is_active) params.set('is_active', 'true')
  const res = await api.get(`event/admin/internal-tags/?${params.toString()}`)
  return res.data
}

export const postInternalTag = async (data: Partial<InternalTag>) => {
  const res = await api.post('event/admin/internal-tags/', data)
  return res.data
}

export const patchInternalTag = async ({ id, data }: { id: string; data: Partial<InternalTag> }) => {
  const res = await api.patch(`event/admin/internal-tags/${id}/`, data)
  return res.data
}

export const deleteInternalTag = async ({ id }: { id: string }) => {
  const res = await api.delete(`event/admin/internal-tags/${id}/`)
  return res.data
}
